import { Items } from "../../../../../core";

export const  reazonRejection = {
    hasDisabledInput: (element: any): boolean => {
      return !element.processedAmount && element.state === 'Entregado'
    },
    filter: false,
    checkbox: false,
    expandable: false,
    show: 'Listado de items a rechazar',
    disabled: false,
    partialField: '',
    paginatorAllData: true,
    columns: [
      {
        title: 'Despacho',
        name: 'dispatchId',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'reazonRejection-dispatchId',
        value: (element: any) => element.dispatchId
      },
      {
        title: 'SKU',
        name: 'skuCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Items) => element.skuCode
      },
      {
        title: 'Descripcion',
        name: 'skuName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Items) => element.skuName
      },
      {
        title: 'Cant. Actual',
        name: 'currentAmount',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Items) => element.currentAmount
      },
      {
        title: 'Cant. a cancelar',
        name: 'processedAmount',
        type: 'number',
        editable: true,
        class: 'center',
        value: (element: Items) => {
          return { num: element.processedAmount, min: 0, max: element.currentAmount }
        }
      },
      {
        title: 'Motivo de rechazo',
        name: 'listReazon',
        type: 'select',
        editable: true,
        class: 'center',
        placeholderHidden: true,
        value: (element: any) => element.listReazon
      }
    ],
  }